import { Buffer } from 'buffer';
import { isDev } from 'static/script/utils/environment';

const getCookieNameForEnvironment = name => (isDev() ? `${name}_test` : name);

export const AUTH_ACCESS_TOKEN_COOKIE_NAME = getCookieNameForEnvironment(
    'trd_at'
);
export const AUTH_REFRESH_TOKEN_COOKIE_NAME = getCookieNameForEnvironment(
    'trd_rt'
);
export const AUTH_PERSIST_COOKIE_NAME = getCookieNameForEnvironment('trd_rk');

export const mightBeLoggedIn = req =>
    Boolean(req.cookies[AUTH_REFRESH_TOKEN_COOKIE_NAME]);

const getJwtPayload = jwtToken => {
    const [, payload] = (jwtToken || '').split('.');
    if (!payload) {
        return {};
    }
    try {
        return JSON.parse(Buffer.from(payload, 'base64').toString());
    } catch (error) {
        return {};
    }
};

export const isTokenExpiringSoon = token => {
    const { exp: expiry } = getJwtPayload(token);
    if (!expiry) {
        return true;
    }
    const now = new Date();
    const expiryDate = new Date(expiry);
    const expiresSoonDate = new Date(expiryDate.getTime() - 60 * 1000);
    const isExpired = expiresSoonDate <= now;
    return isExpired;
};

export const addCookie = (res, cookie) => {
    const previouslySetCookies = res.getHeader('Set-Cookie');
    if (Array.isArray(previouslySetCookies)) {
        res.setHeader('Set-Cookie', [...previouslySetCookies, cookie]);
    } else if (previouslySetCookies) {
        res.setHeader('Set-Cookie', [previouslySetCookies, cookie]);
    } else {
        res.setHeader('Set-Cookie', cookie);
    }
};
